const endpoint = "https://apiadminip.suramericana.com.co";

export const environment = {
  production: true,
  //Endpoints
  companiaEndPoint: endpoint + "/appadminip/api/companias/",
  ciudadEndPoint: endpoint + "/appadminip/api/ciudades/",
  sedeEndPoint: endpoint + "/appadminip/api/sedes/",
  listaItemEndPoint: endpoint + "/appadminip/api/listaitems/",
  vlanEndPoint: endpoint + "/appadminip/api/vlans/",
  tipoAsignacionEndPoint: endpoint + "/appadminip/api/tipoasignacion/",
  administradorIpEndPoint: endpoint + "/appadminip/api/admin/",
  sesionEndPoint: endpoint + "/appadminip/api/sesion",
  inicioEndPoint: endpoint + "/appadminip/api/inicio",
  asignacionEndPoint: endpoint + "/appadminip/api/asignacion/",
  vlanSedeEndPoint: endpoint + "/appadminip/api/vlansede/",
  superNetEndPoint: endpoint + "/appadminip/api/supernet/",

  listaCodigoAmbientes: "AMBIEN",
  listaCodigoUrl: "LISURL",
  listaCodigoServidor: "LISSER",
  listaCodigoEquipos: "LISEQU",
  listaCodigoServicio: "SEITNE",
  listaCodigoPlataforma: "LISPLA",
  listaCodigoRol: "LISROL",
  listaCodigoMascara: "MASCAR",
  listaItemAmbienteSedes: "AMBSED",
  listaItemMascaraCloud: "4",

  tipoAsignacionManual: "MANUAL",

  miximoIpLiberar: 10,

  fechaInicial: "1989-05-13",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts